import React from 'react';
import { useDispatch } from 'react-redux';

import { createSolutionCaseStudy } from '@actions/caseStudies';

import Modal from 'lib/src/components/modal/Modal';
import NetworkingHubCaseStudyForm from './NetworkingHubCaseStudyForm';

const NetworkingHubSubmitSolutionModal = ({ closeModal }) => {
    const dispatch = useDispatch();

    return (
        <Modal title="Submit a solution" closeModal={closeModal}>
            <div className="wysiwyg description">
                <p>Enter the details below to submit a solution.</p>
            </div>

            <NetworkingHubCaseStudyForm handleSubmit={handleSubmit} onCancel={closeModal} />
        </Modal>
    );

    function handleSubmit(postBody) {
        dispatch(createSolutionCaseStudy(postBody));
    }
};

export default NetworkingHubSubmitSolutionModal;
